import { Box, Modal } from "@mui/material";
import Button from "@mui/material/Button";
import React, { useState, useRef, useEffect } from "react";
import topArrow from '../../assests/images/top.png';
import topHighlightArrow from '../../assests/images/top-highlighted.png';
import bottomArrow from '../../assests/images/bottom.png';
import bottomHighlightArrow from '../../assests/images/bottom-highlighted.png';
import { Editor } from "react-draft-wysiwyg";
import checkImage from "../../assests/images/check-circle.png"; 
import { isEmptyDash, strToDate, strToDateYYMMDD } from "../../constant";
import { rfqServices } from "../../services/rfqServices";
import { EditorState, convertToRaw } from "draft-js"; 
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";  
import draftToHtml from "draftjs-to-html";
import { htmlDocs } from "../buyerPurchaseOrder/draftToHtml";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import { toWords } from "number-to-words";
import { Empty } from "antd";

const initialColumnsApprove = [
  { id: "Sr.no.", label: "Sr. No.", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "vendorsname", label: "Vendor’s Name", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "vendorstatus.", label: "Vendor Status", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "quotationreceived", label: "Quotation Received", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "technicallyacceptable", label: "Technically Acceptable", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
];
const comparisonColumn = [
  { id: "Sr.no.", label: "Sr. No.", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "vendorsname", label: "Vendor’s Name", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "vendorCode.", label: "Vendor Code", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "bidPosition", label: "Bid Positions", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "technicalRecomendation", label: "Technical Recommendation", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "initalBidAmount", label: "Initial Bid Amount", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "reverseAuctionAmount", label: "Reverse Auction Amount", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "finalNegotiate", label: "Final Negotiated Amount", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "reductionInitial", label: "Reduction (%) w.r.t. Initial", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
];
  
const nfastyle1 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "70%",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  const style1 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };


function NfaApprovalModal(props) {  
    const id = props?.rfqId?._id; 
     const [isLoading, setIsLoading] = useState(false);
    const [comparisonColumns, setComparisonColumns] = useState(comparisonColumn); 
    const [getNFACommercialDetails, setSetNFACommercialDetails] = useState(false);
    const [opennfaapprovelmodalsubmit, setOpenNfaApprovelModalSubmit] =
    useState(false);
    const [opennfamodalsuccess, setOpenNfaModalSuccess] =
    useState(false);
    const [approvecolumns, setApproveColumns] = useState(initialColumnsApprove);
    const onSortChange = (index, sortBy, sortOrder) => {
        let newSortLael = (sortOrder == "asc") ? "desc" : "asc";
      }

      const handleCloseAlert = (event, reason) => {
        if (reason === "clickaway") {
          return;
        }
        setAlertComponent({ ...alertComponent, open: false });
      };
    const [buyerApproval, setBuyerApproval] = useState(''); 

     useEffect(() => { 

      if(props?.opennfaapprovelmodal === true){
        getNFACommercialComparrsionDetails(id);
        getComparsionDetails(id);
        getBuyerApproval();
      } 
     }, [props?.opennfaapprovelmodal]); 


      const [alertComponent, setAlertComponent] = useState({
           open: false,
           message: "",
           type: "",
         });

     const getNFACommercialComparrsionDetails = (id) => {
       setIsLoading(true); 
       let bodyData = "?allVendors=true"; 
       rfqServices.getNFACommercialComparison(id ,bodyData)
         .then((res) => {
           if (res && res.data) { 
             setSetNFACommercialDetails(res?.data?.data);
             setApprNFADetails(res?.data?.data);
           } else { 
           }
         })
         .catch((error) => { 
         })
         .finally(() => {
           setIsLoading(false);
         });
     };

     const [comparsionDetail, setComparsionDetails] = useState(''); 
     
     const getComparsionDetails = (id) => {
      setIsLoading(true); 
      let bodyData = "?allVendors=true"; 
      rfqServices.getComparsionDetails(id ,bodyData)
        .then((res) => {
          if (res && res.data) { 
            setComparsionDetails(res?.data?.data); 
          } else { 
          }
        })
        .catch((error) => { 
        })
        .finally(() => {
          setIsLoading(false);
        });
       };

     const getBuyerApproval = () => {
       setIsLoading(true);
       let param = "?departments=PROCUREMENT";
       rfqServices
         .getAssignEngineer(param)
         .then((res) => {
           if (res && res.data) {
             setBuyerApproval(res?.data?.data);
           } else {
             setAlertComponent({
               open: true,
               type: 'error',
               message: 'No Data Found',
             });
           }
         })
         .catch((error) => {
         
         })
         .finally(() => {
           setIsLoading(false);
         });
     };
   


     const [NFADetails, setApprNFADetails] = useState({
       wbsElement : "",
       vendor : "",
       l1Approver:"",
       orderValue: { amount: null, inWords: "", excluding: "" },
       benchmarkPrice: { amount: null, inWords: "", excluding: "" },
       applicableTaxes: "",
       terms: "",
       deliveryPeriod: null,
       freeIssueMaterials: "",
       paymentTerms: "",
       ldApplicable: "",
       bgApplicable: "",
       otherTnc: "",
       deviationFromTerms: "",
       backgroundAndBidDetails: "",
       recommendation: "",
       budgetHead: "",
       budgetAmount: null,
       thisProposal: null,
       balanceBudget: null,
       remarks: "",
       subject : "", 
       editorStateTwo: "",
       finalNegotiatedAmount:null,
       project : "",
       package : "",
       location: ""
     });
     
    const onDetailsInputChange1 = (e) => {
      const { name, value } = e.target;
      setApprNFADetails((prevData) => ({
        ...prevData,
        [name]: value, // Update the field dynamically based on the `name`
      }));
    };

    const toIndianWords = (num) => {
      const words = toWords(num);  
      const capitalizeWords = (str) => {
        return str
          .split(' ')  
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))  
          .join(' ');  
      };
    
      // Convert large numbers to Indian system (Lakh, Crore, etc.)
      const convertToIndianFormat = (number) => {
        let result = '';
    
        // Handle cases for crore, lakh, thousand, etc.
        if (number >= 10000000) {
          const crore = Math.floor(number / 10000000);
          result += toWords(crore) + " crore ";
          number %= 10000000;
        }
    
        if (number >= 100000) {
          const lakh = Math.floor(number / 100000);
          result += toWords(lakh) + " lakh ";
          number %= 100000;
        }
    
        if (number >= 1000) {
          const thousand = Math.floor(number / 1000);
          result += toWords(thousand) + " thousand ";
          number %= 1000;
        }
    
        if (number > 0) {
          result += toWords(number);
        }
    
        return result.trim();
      };
    
      // Capitalize the first letter of each word in the result
      const indianFormattedWords = convertToIndianFormat(num);
      return capitalizeWords(indianFormattedWords);
    };
    

    const onDetailsInputChange = (e) => {
      const { name, value } = e.target;
      const newValue = value;
    
      setApprNFADetails((prevData) => {
        const newData = { ...prevData };
        const keyPath = name.split(".");
    
        if (keyPath.length === 2) {
          const parentKey = keyPath[0];
          const childKey = keyPath[1];
    
          // Ensure the parent object exists
          if (!newData[parentKey]) {
            newData[parentKey] = {}; // Initialize if undefined
          }
    
          newData[parentKey][childKey] = newValue;
    
          // Special logic for amount fields
          if (parentKey === "orderValue" && childKey === "amount") {
            newData[parentKey].inWords = value ? toIndianWords(value) : "";
          }
          if (parentKey === "benchmarkPrice" && childKey === "amount") {
            newData[parentKey].inWords = value ? toIndianWords(value) : "";
          }
        } else {
          // Handle flat keys
          newData[name] = newValue;
        }
    
        // Recalculate balanceBudget if applicable
        if (newData?.budgetAmount && newData?.thisProposal !== undefined) {
          newData.balanceBudget = newData.budgetAmount - newData.thisProposal;
        }
    
        return newData;
      });
    };
    
     

      
     const [backgroundBidDetails, setBackgroundBidDetails] = React.useState({
      backgroundAndBidDetails: EditorState.createWithContent(htmlDocs("<p></p>"))
    }); 

    const [recommendationDetials, setRecommendationDetials] = React.useState({
      recommendation: EditorState.createWithContent(htmlDocs("<p></p>"))
    }); 
     
     const onEditorStateChangeOne = (editorState) => {
      setBackgroundBidDetails((prevState) => ({
        ...prevState,
        backgroundAndBidDetails: editorState,
      }));
    };
    
    const onEditorStateChangeTwo = (editorState) => {
      setRecommendationDetials((prevState) => ({
        ...prevState,
        recommendation: editorState,
      }));
    };

    const [negotiateAmounts, setNegotiateAmounts] = useState({});

    // const calculatePercentageDifference =(vendorID , finalNegotiatedAmount , originalAmount)=>{ 
    //   const updatedNegotiatedAmount = parseFloat(finalNegotiatedAmount) || 0;
    //   const updatedPercentageDifference =
    //     originalAmount > 0
    //       ? (((updatedNegotiatedAmount - originalAmount) * 100) / originalAmount).toFixed(2)
    //       : "N/A";
    //       setNegotiateAmount(updatedPercentageDifference);
    //       setApprNFADetails((prevState) => ({
    //         ...prevState, 
    //         "finalNegotiatedAmount" : updatedNegotiatedAmount
    //       }));

    // }

    const calculatePercentageDifference = (vendorID, finalNegotiatedAmount, originalAmount) => {
      const updatedNegotiatedAmount = parseFloat(finalNegotiatedAmount) || 0;
      const updatedPercentageDifference =
        originalAmount > 0
          ? (((updatedNegotiatedAmount - originalAmount) * 100) / originalAmount).toFixed(2)
          : "N/A";
    
          setApprNFADetails((prevDetails) => ({
        ...prevDetails,
        [vendorID]: {
          ...prevDetails[vendorID],
          finalNegotiatedAmount: updatedNegotiatedAmount,
          percentageDifference: updatedPercentageDifference,
        },
      }));
    };

    const safeBtoa = (str) => {
     return btoa(unescape(encodeURIComponent(str)));
    //   return btoa(str);
    }

    
    const handleSubmit = () => {
      if(isEmptyDash(NFADetails?.l1Approver)){
        setAlertComponent({ open: true,  type: 'error', message: "Please Select Approver Name"});
        props?.setOpenNfaApprovelModal(true);
        return false;
      }
      if(isEmptyDash(NFADetails?.vendor)){
        setAlertComponent({ open: true,  type: 'error', message: "Please Select Order recommended on (Party)"});
        props?.setOpenNfaApprovelModal(true);
        return false;
      }
      if(isEmptyDash(NFADetails?.orderValue?.amount)){
        setAlertComponent({ open: true,  type: 'error', message: "Please Enter Order Value"});
        props?.setOpenNfaApprovelModal(true);
        return false;
      }
      
      setIsLoading(true);
      const vendorData = getNFACommercialDetails?.rfqVendors?.map((vendor) => ({
        vendorId: vendor.vendorId,
        finalNegotiatedAmount: NFADetails?.[vendor.vendorId]?.finalNegotiatedAmount,
      }));
     
       const submissionData = {
         rfqId : id,
         l1Approver:NFADetails?.l1Approver,
         vendor : NFADetails?.vendor ,
         subject : NFADetails?.subject ,
         wbsElement:NFADetails?.wbsElement,
         orderValue: {
           amount: parseFloat(NFADetails?.orderValue?.amount),
           inWords: NFADetails?.orderValue?.inWords,
           excluding: NFADetails?.orderValue?.excluding,
         },
         benchmarkPrice: {
           amount: parseFloat(NFADetails?.benchmarkPrice?.amount),
           inWords: NFADetails?.benchmarkPrice?.inWords,
           excluding: NFADetails?.benchmarkPrice?.excluding,
         },
         applicableTaxes: NFADetails?.applicableTaxes,
         terms: NFADetails?.terms,
         deliveryPeriod: (NFADetails?.deliveryPeriod) ? NFADetails?.deliveryPeriod : null,
         freeIssueMaterials: NFADetails?.freeIssueMaterials,
         paymentTerms: NFADetails?.paymentTerms,
         ldApplicable: NFADetails?.ldApplicable,
         bgApplicable: NFADetails?.bgApplicable,
         otherTnc: NFADetails?.otherTnc,
         deviationFromTerms: NFADetails?.deviationFromTerms,


       
        backgroundAndBidDetails: safeBtoa(draftToHtml(convertToRaw(backgroundBidDetails?.backgroundAndBidDetails?.getCurrentContent()))) ,
        recommendation: safeBtoa(draftToHtml(convertToRaw(recommendationDetials?.recommendation?.getCurrentContent()))) ,

         budgetHead: NFADetails?.budgetHead,
         budgetAmount: NFADetails?.budgetAmount,
         thisProposal: NFADetails?.thisProposal,
         balanceBudget: NFADetails?.balanceBudget,
         remarks: NFADetails?.remarks,
         project: NFADetails?.project,
        package: NFADetails?.package,
        location: NFADetails?.location,
         vendorData:vendorData
        };   
       rfqServices
         .createnfs(submissionData)
         .then((res) => { 
          if (res && res.data) {
            setOpenNfaModalSuccess(true);
            props?.setOpenNfaApprovelModal(false);
            // setAlertComponent({ open: true, type: "success", message: res.data.message });
          } else { 
            props?.setOpenNfaApprovelModal(true);
             setAlertComponent({
               open: true,
               type: 'error',
               message: res.data.message,
             });
           }
         })
         .catch((error) => {
          props?.setOpenNfaApprovelModal(true);
           setAlertComponent({
             open: true,
             type: 'error',
             message: `${error?.response?.data?.message}`,
           }); 
         })
         .finally(() => {
           setIsLoading(false);
         }); 
    };

  return (     
        <> 
           <Modal
            open={props?.opennfaapprovelmodal}
            onClose={() => props?.setOpenNfaApprovelModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={nfastyle1} className="modal_appointmagamentsites_rew">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">Note for Approval</h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => props?.setOpenNfaApprovelModal(false)}
                ></button>
              </div>
              <div class="modal-body">
                <div className="modal_row_noteapprove">
                    <div className="note_approvel">
                      <p className="ref_approvel">Ref. No</p>
                      <p className="rfq_number_note">: {props?.rfqId?.rfqNumber}</p>
                    </div>
                    <div className="note_approvel">
                      <p className="ref_approvel">Request Date</p>
                      <p className="rfq_number_note">: {strToDate(new Date())}</p>
                    </div>
                </div>
                {/* <div className="modal_row_noteapproved_maine">
                    <div className="note_approvel">
                      <p className="ref_approvel">No. of pages</p>
                      <p className="rfq_number_note">: 23</p>
                    </div>
                </div> */}
                <div className="row1_nfa_danger_solar">
                  <div className="tabs_note_approvel_body">
                    <p className="project_text">
                      Project Name</p>
                       <input type="text" className="form-control note_inpur" placeholder="" name="project" onChange={onDetailsInputChange} value={NFADetails?.project} /> 
                  </div>
                  <div className="tabs_note_approvel_body">
                    <p className="project_text">
                    Location</p> 
                    <input type="text" className="form-control note_inpur" placeholder="" name="location" onChange={onDetailsInputChange} value={NFADetails?.location} /> 
                  </div>
                  <div className="tabs_note_approvel_body">
                    <p className="project_text">
                    Package </p> 
                    <input type="text" className="form-control note_inpur" placeholder="" name="package" onChange={onDetailsInputChange} value={NFADetails?.package} /> 
                  </div>
                  <div className="tabs_note_approvel_body">
                    <p className="project_text">
                    WBS Element</p>
                    <input type="text" className="form-control note_inpur" placeholder="" name="wbsElement" onChange={onDetailsInputChange} />
                  </div>
                  <div className="tabs_note_approvel_body">
                    <p className="project_text">
                    Approve Name<span class="required">*</span></p>
                    <td>
                      <select className="form-select w-100 lets_onboarding_wizard_react" aria-label="Default select example" name="l1Approver" onChange={onDetailsInputChange}>
                        <option value={""} >Select Approval Name</option> 
                        {buyerApproval?.assignees?.map((ele, i) => (
                          <>
                            <option value={ele?._id}>
                              {ele?.name}
                            </option>
                          </>
                        ))} 
                        </select>
                    </td>
                  </div>
                  </div>
                  <div className="row_maine_block_uinpit">
                      <div className="maine_box1_tabs">
                        
                        <div className="inssue_bodyy maine_issue_colume">
                          <p className="text_project_final">Subject:</p>
                          <p className="date_text">
                              <input type="text" class="form-control form-hanfa" placeholder="" value={NFADetails?.subject}  name="subject" onChange={onDetailsInputChange} />
                          </p>
                        </div>

                        <div className="inssue_bodyy maine_issue_colume">
                          <p className="text_project_final">Issued On :</p>
                          <p className="date_text">{strToDate(getNFACommercialDetails?.rfqPublishDate)}</p>
                        </div>
                        {/* <div className="inssue_bodyy maine_issue_colume">
                          <p className="text_project_final">Publish date :</p>
                          <p className="date_text">{strToDate(getNFACommercialDetails?.rfqPublishDate)}</p>
                        </div> */}
                        <div className="inssue_bodyy maine_issue_colume">
                          <p className="text_project_final">Final Bid Due Date :</p>
                          <p className="date_text">{strToDate(getNFACommercialDetails?.finalBidDueDate)}</p>
                        </div>
                        {/* <div className="maine_issue_colume">
                          <p className="text_project_final">System End Date :</p>
                          <p className="date_text">05-12-2024</p>
                        </div> */}
                      </div>
                    </div>

                  <div className="bidding_detail_approved">
                  <div className="detail_bidding_nfa">
                      <h5 className="detail_nfe">A. Bidding Details</h5>
                    </div>
                  <div className="listing_main listing_main_dragdropcontext_body" style={{marginBottom:"20px"}}>
                      <table className="">
                        <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                          <tr>
                            {approvecolumns.map((approvecolumns, index) => (<>
                              <th className="vendor_tabels ">
                                <div className="PoDetailTableHeading">
                                  <div className="d-flex">
                                    <p>{approvecolumns?.label}</p>
                                    {(approvecolumns.isSort == true) && <span onClick={(e) => onSortChange(index, approvecolumns.id, approvecolumns.sortLabel)} className="table-sort-ico">
                                      {(approvecolumns.sortLabel != "asc") && <img src={topArrow} />}
                                      {(approvecolumns.sortLabel == "asc") && <img src={topHighlightArrow} />}
                                      {(approvecolumns.sortLabel != "desc") && <img src={bottomArrow} />}
                                      {(approvecolumns.sortLabel == "desc") && <img src={bottomHighlightArrow} />}
                                    </span>}
                                  </div>
                                </div>
                              </th>
                            </>))}
                          </tr>
                        </thead>
                      <tbody style={{ overflowY: "scroll", width: "200px" }}>
                        {getNFACommercialDetails.length < 1 && <>
                          <tr>
                            <td colSpan={8} className="text-center list-no-data">No Data Found</td>
                          </tr>
                        </>}
                        {getNFACommercialDetails?.rfqVendors?.map((vendorData, i) => (<> 
                          <tr className="maine_tr_vendor">
                            <td>{i+1}</td>
                            <td>{vendorData?.vendorName}</td>
                            <td>{vendorData?.category}</td>
                            <td>{vendorData?.participationStatus === "Submitted" ? "Yes" : "No"}</td>
                            {/* <td>{vendorData?.technicalStatus === "Approved" ? "Yes" : "No"}</td> */}
                            <td>{(vendorData.technicalStatus === "NA" || vendorData.technicalStatus === "Pending" ) ? "NA" : vendorData.technicalStatus === "Approved" ? "Yes"  : "No"}</td>
                          </tr>
                        </>))} 
                      </tbody>
                    </table>
                  </div>



                  <div className="detail_bidding_nfa">
                   <h5 className="detail_nfe">B. Order Details</h5>
                </div> 
            <div className="listing_main listing_main_dragdropcontext_body">
              <table>
                <thead>
                  <tr>
                    <th>Perticularls</th>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Order recommended on (Party)<span class="required">*</span></td>
                    <td>
                      <select className="form-select w-100 lets_onboarding_wizard_react" aria-label="Default select example" name="vendor" onChange={onDetailsInputChange}>
                         <option value="">Select Vendor Name</option>
                          {getNFACommercialDetails?.rfqVendors?.map((vendorData, i) => (
                            <option value={vendorData?.vendorId}>{vendorData?.vendorName}</option>
                          ))}  
                        </select>
                        </td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Order Value<span class="required">*</span></td>
                    <td><input type="number" class="form-control form-hanfa" placeholder="" name="orderValue.amount" value={NFADetails?.orderValue?.amount} onChange={onDetailsInputChange} /></td>

                    <td><input type="text" class="form-control form-hanfa" placeholder="" value={NFADetails?.orderValue?.inWords} name="orderValue.inWords" onChange={onDetailsInputChange} readOnly /></td>

                    <td><input type="text" class="form-control form-hanfa" placeholder="" value={NFADetails?.orderValue?.excluding} name="orderValue.excluding" onChange={onDetailsInputChange}/></td>
                  </tr>

                  <tr>
                    <td>Benchmark Price/ Last Purchase Price Value</td>
                    <td><input type="number" class="form-control form-hanfa" placeholder="" name="benchmarkPrice.amount" value={NFADetails?.benchmarkPrice?.amount} onChange={onDetailsInputChange} /></td>

                    <td><input type="text" class="form-control form-hanfa" name="benchmarkPrice.inWords"
                     placeholder="" value={NFADetails?.benchmarkPrice?.inWords}  onChange={onDetailsInputChange}  /></td>

                    <td><input type="text" class="form-control form-hanfa"  name="benchmarkPrice.excluding"
                      placeholder="" value={NFADetails?.benchmarkPrice?.excluding} onChange={onDetailsInputChange}  /></td>

                  </tr>


                  <tr>
                    <td>Applicable Taxes & Duties</td>
                    <td><input type="text" class="form-control form-hanfa" name="applicableTaxes"   placeholder="" value={NFADetails?.applicableTaxes}
                      onChange={onDetailsInputChange}/></td>
                    <td></td>
                    <td></td>
                  </tr>

                  <tr>
                    <td>Terms(EXW/ FOR/ FOB/ CIF)</td>
                    <td><input type="text" class="form-control form-hanfa" placeholder="" value={NFADetails?.terms}  name="terms" onChange={onDetailsInputChange} /></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Delivery/ Completion  Period</td>
                    <td><input type="date" class="form-control form-hanfa" placeholder="" name="deliveryPeriod" onChange={onDetailsInputChange} value={NFADetails?.deliveryPeriod} /></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Free Issue Materials</td>
                    <td><input type="text" class="form-control form-hanfa" placeholder="" name="freeIssueMaterials" onChange={onDetailsInputChange} value={NFADetails?.freeIssueMaterials} /></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Payment terms</td>
                    <td><input type="text" class="form-control form-hanfa" placeholder="" name="paymentTerms" onChange={onDetailsInputChange} value={NFADetails?.paymentTerms} /></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Whether LD applicable</td>
                    <td><input type="text" class="form-control form-hanfa" placeholder="" name="ldApplicable" onChange={onDetailsInputChange} value={NFADetails?.ldApplicable} /></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Whether ABG, CPBG and PBG  applicable</td>
                    <td><input type="text" class="form-control form-hanfa" placeholder="" name="bgApplicable" onChange={onDetailsInputChange} value={NFADetails?.bgApplicable} /></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Any Other Terms and Conditions</td>
                    <td><input type="text" class="form-control form-hanfa" placeholder="" name="otherTnc" onChange={onDetailsInputChange} value={NFADetails?.otherTnc} /></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Any deviation from Standard Terms</td>
                    <td><input type="text" class="form-control form-hanfa" placeholder="" name="deviationFromTerms" onChange={onDetailsInputChange} value={NFADetails?.deviationFromTerms}/></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

            </div>


            <div className="detail_bidding_nfa">
            <h5 className="detail_nfe">C. Background & Bid Details</h5>
            </div>
              <Editor
                editorState={backgroundBidDetails?.backgroundAndBidDetails}
                toolbarClassName="toolbarClassName"
                wrapperClassName="wrapperClassName"
                editorClassName="editorClassName" 
                onEditorStateChange={onEditorStateChangeOne}
               />
              <div className="detail_bidding_nfa">
                  <h5 className="detail_nfe">D. Comparison of Bids</h5>
            </div>
            <div className="listing_main listing_main_dragdropcontext_body comparsion_bidding_table">
                <table>
                    <thead> 
                      <tr>
                        {comparisonColumns.map((comparisonColumns, index) => (<>
                          <th className="vendor_tabels ">
                            <div className="PoDetailTableHeading">
                              <div className="d-flex">
                                <p>{comparisonColumns?.label}</p>
                                {(comparisonColumns.isSort == true) && <span onClick={(e) => onSortChange(index, comparisonColumns.id, comparisonColumns.sortLabel)} className="table-sort-ico">
                                  {(comparisonColumns.sortLabel != "asc") && <img src={topArrow} />}
                                  {(comparisonColumns.sortLabel == "asc") && <img src={topHighlightArrow} />}
                                  {(comparisonColumns.sortLabel != "desc") && <img src={bottomArrow} />}
                                  {(comparisonColumns.sortLabel == "desc") && <img src={bottomHighlightArrow} />}
                                </span>}
                              </div>
                            </div>
                          </th>
                        </>))}
                      </tr>
                    </thead>
                    <tbody>
                       {comparsionDetail.length < 1 && <>
                            <tr>
                              <td colSpan={8} className="text-center list-no-data">No Data Found</td>
                            </tr>
                          </>}
                          {comparsionDetail?.rfqVendors?.map((vendorData, i) => (<>
                          
                            <tr className="maine_tr_vendor">
                              <td>{i+1}</td>
                              <td>{vendorData?.vendorName}</td>
                              <td>{vendorData?.vendorCode}</td> 
                              <td>{(vendorData?.rank) ? `L${vendorData?.rank}`:''}</td>  
                              <td>{vendorData?.technicalStatus}</td> 
                              <td>{vendorData?.boqs[0]?.totalAmount}</td>
                              <td> {vendorData?.vendorData[1]?.totalAmount 
                                  ? `${vendorData.vendorData[1].totalAmount}` 
                                  : "N/A"}</td>
                             <td> 
                             <input type="text" class="form-control form-hanfa" placeholder="" name="finalNegotiatedAmount" 
                              value={NFADetails?.[vendorData?.vendorId]?.finalNegotiatedAmount }
                                onChange={(e) =>calculatePercentageDifference(vendorData?.vendorId , e.target.value,vendorData?.boqs[0]?.totalAmount) }
                               />
                             </td>
                             <td>{NFADetails?.[vendorData?.vendorId]?.percentageDifference ?? ""} %</td>
                            </tr>
                          </>))}  
                    </tbody>
                </table>
            </div>


            <div className="listing_main listing_main_dragdropcontext_body table_bidding">
              <table>
                <thead>
                    <tr>
                        <th>Budget Head</th>
                        <th>Budget Amount</th>
                        <th>This Proposal</th>
                        <th>Balance/ Additional Budget Required</th>
                        <th>Remarks</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                    <td><input type="text" class="form-control form-hanfa" placeholder="" name="budgetHead" value={NFADetails?.budgetHead} onChange={onDetailsInputChange} /></td>

                    <td><input type="number" class="form-control form-hanfa" placeholder="" name="budgetAmount" value={NFADetails?.budgetAmount} onChange={onDetailsInputChange} /></td>
                    <td><input type="number" class="form-control form-hanfa" placeholder="" name="thisProposal" value={NFADetails?.thisProposal} onChange={onDetailsInputChange} /></td>
                    <td><input type="number" class="form-control form-hanfa" placeholder="" name="balanceBudget" value={NFADetails?.balanceBudget} onChange={onDetailsInputChange} /></td>
                    <td><input type="text" class="form-control form-hanfa" placeholder="" name="remarks" value={NFADetails?.remarks} onChange={onDetailsInputChange} /></td>
                    </tr>
                </tbody>
              </table> 
            </div>

            <div className="detail_bidding_nfa">
            <h5 className="detail_nfe">Recommendation</h5>
            </div>
                <Editor
                  editorState={recommendationDetials?.recommendation}
                  toolbarClassName="toolbarClassName"
                  wrapperClassName="wrapperClassName"
                  editorClassName="editorClassName"
                  onEditorStateChange={onEditorStateChangeTwo}
                />
          </div>   


                <div class="all_btn_nfa submit_btn_forn_qccreation">
                  <button
                    type="button"
                    class="btn btn btn-danger"
                    onClick={() => {
                        props?.setOpenNfaApprovelModal(false);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    class="btn btn-success save_next_btns"
                    onClick={() => {
                        props?.setOpenNfaApprovelModal(false);
                         setOpenNfaApprovelModalSubmit(true);
                    }}

                    //onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </Box>

          </Modal>

          {/*NFA Modal Submit */}
          <Modal
            open={opennfaapprovelmodalsubmit}
            onClose={() => setOpenNfaApprovelModalSubmit(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenNfaApprovelModalSubmit(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p>
                Are you sure you want to submit this <b>NFA</b>?
                </p>
                <div class="lets_no_btn_danger_yes_technical_project">
                  <button
                    type="button"
                    class="btn btn btn-danger"
                    onClick={() => { 
                      props?.setOpenNfaApprovelModal(true);
                    }}
                  >
                    No
                  </button>
                  <button
                    type="button"
                    class="btn btn-success"
                    onClick={() => {
                      setOpenNfaApprovelModalSubmit(false); // Close the confirmation modal
                      handleSubmit(); // Call the submit function
                    }}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </Box>
          </Modal>

            {/*NFA Modal Successfully */}
            <Modal
            open={opennfamodalsuccess}
            onClose={() => setOpenNfaModalSuccess(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => {setOpenNfaModalSuccess(false); window.location.reload();}}
                ></button>
              </div>
              <div class="modal-bodys">
              <img src={checkImage} alt="" />
                <p>
                <b>NFA</b> has been submitted successfully
                </p>
                <div class="lets_no_btn_danger_yes_technical_project">
                  <button
                    type="button"
                    class="btn btn-success"
                    onClick={() => {
                        setOpenNfaModalSuccess(false);
                        window.location.reload();
                    }}
                  >
                    Ok
                  </button>
                </div>
              </div>
              
            </Box>
            </Modal>

          <AlertComponent
              alertComponent={alertComponent}
              handleClose={handleCloseAlert}
            />
            <Backdrop
              sx={{
                color: "#fff",
                zIndex: (theme) => 99999,
              }}
              open={isLoading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
        </>
  )
}

export default NfaApprovalModal